import React from 'react';
import PageScreenDefault from '../../components/screen/PageScreenDefault';

const Rising = () => <PageScreenDefault url="rising" />;
export default Rising;
